/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listDiseases = /* GraphQL */ `
  query ListDiseases(
    $normalizedName: String
    $filter: ModelDiseaseFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDiseases(
      normalizedName: $normalizedName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
      nextToken
    }
  }
`;
export const getDisease = /* GraphQL */ `
  query GetDisease($normalizedName: String!) {
    getDisease(normalizedName: $normalizedName) {
      normalizedName
      name
      owner
      description
      removed
      gsiPartition
      createdAt
      updatedAt
      symptoms
      reviews {
        nextToken
      }
    }
  }
`;
export const diseasesSortedByName = /* GraphQL */ `
  query DiseasesSortedByName(
    $gsiPartition: String
    $normalizedName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDiseaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    diseasesSortedByName(
      gsiPartition: $gsiPartition
      normalizedName: $normalizedName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
      nextToken
    }
  }
`;
export const diseasesSortedByUpdatedAt = /* GraphQL */ `
  query DiseasesSortedByUpdatedAt(
    $gsiPartition: String
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDiseaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    diseasesSortedByUpdatedAt(
      gsiPartition: $gsiPartition
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
      nextToken
    }
  }
`;
export const getReview = /* GraphQL */ `
  query GetReview($id: ID!) {
    getReview(id: $id) {
      id
      diseaseNormalizedName
      owner
      rating
      comment
      createdAt
      updatedAt
      disease {
        normalizedName
        name
        owner
        description
        removed
        gsiPartition
        createdAt
        updatedAt
        symptoms
      }
    }
  }
`;
export const listReviews = /* GraphQL */ `
  query ListReviews(
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        diseaseNormalizedName
        owner
        rating
        comment
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
